import { render, staticRenderFns } from "./SimpleWitget.vue?vue&type=template&id=79f5926c&scoped=true"
import script from "./SimpleWitget.ts?vue&type=script&lang=ts&external"
export * from "./SimpleWitget.ts?vue&type=script&lang=ts&external"
import style0 from "./SimpleWitget.vue?vue&type=style&index=0&id=79f5926c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5926c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f5926c')) {
      api.createRecord('79f5926c', component.options)
    } else {
      api.reload('79f5926c', component.options)
    }
    module.hot.accept("./SimpleWitget.vue?vue&type=template&id=79f5926c&scoped=true", function () {
      api.rerender('79f5926c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ProcessesSection/SimpleWitget/SimpleWitget.vue"
export default component.exports